module.exports = __webpack_public_path__ + "img/design.abf23590.jpg";